var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("div", { staticClass: "componentTextPersona" }, [
    _c("i", { staticClass: "fa-solid fa-user-tie-hair" }),
    _c("p", { staticClass: "title-text-persona" }, [
      _vm._v(
        _vm._s(
          _vm.$t("dash.reporting.section.demographie.subtitle.profil_type")
        )
      ),
    ]),
    _c("div", { staticClass: "genre" }, [
      _vm.stats.audience_gender[0].name == "M"
        ? _c("h3", [
            _vm._v(
              _vm._s(_vm.$t("dash.reporting.section.demographie.type_man"))
            ),
          ])
        : _vm._e(),
      _vm.stats.audience_gender[0].name == "F"
        ? _c("h3", [
            _vm._v(
              _vm._s(_vm.$t("dash.reporting.section.demographie.type_female"))
            ),
          ])
        : _vm._e(),
      _vm.stats.audience_gender[0].name == "U"
        ? _c("h3", [
            _vm._v(
              _vm._s(
                _vm.$t("dash.reporting.section.demographie.type_undefined")
              )
            ),
          ])
        : _vm._e(),
      _vm.stats.audience_gender[0].name == "M"
        ? _c("i", { staticClass: "fa-solid fa-mars" })
        : _vm._e(),
      _vm.stats.audience_gender[0].name == "F"
        ? _c("i", { staticClass: "fa-solid fa-venus" })
        : _vm._e(),
    ]),
    _c("div", { staticClass: "age" }, [
      _c("p", [
        _vm._v(_vm._s(_vm.$t("dash.reporting.section.demographie.aged"))),
      ]),
      _c("h3", [
        _vm._v(
          _vm._s(_vm.stats.profil_type_age) +
            " " +
            _vm._s(_vm.$t("dash.reporting.section.demographie.years"))
        ),
      ]),
    ]),
    _c("div", { staticClass: "country" }, [
      _c("p", [
        _vm._v(_vm._s(_vm.$t("dash.reporting.section.demographie.from"))),
      ]),
      _c("h3", [
        _vm._v(_vm._s(_vm.getCountryName(_vm.stats.profil_type_country))),
      ]),
    ]),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }